var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "payload-wrapper" },
    [
      _vm._l(_vm.clone, function (attribute, i) {
        return _c("AttributeSetUpdater", {
          key: "attr-" + attribute.attribute + i,
          attrs: {
            "show-remove-button": true,
            "on-removed": function () {
              return _vm.removeAttribute(i)
            },
          },
          model: {
            value: _vm.clone[i],
            callback: function ($$v) {
              _vm.$set(_vm.clone, i, $$v)
            },
            expression: "clone[i]",
          },
        })
      }),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "cbcard-btn", on: { click: _vm.addAttribute } },
        [_c("md-icon", [_vm._v("add")])],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }